<mat-toolbar>
  <div class="brand-logo">
    <img src="/stemi-logo.png" alt="Clinic Logo" width="100%" />
  </div>

  <span class="toggle-sidenav" (click)="changeToggle()">
    <i class="fa fa-bars" aria-hidden="true"></i>
  </span>

  <div class="nav-icons header-main-menu">
    <!-- Notification Section -->
    <!-- <a class="position-relative" (click)="notifyPanelToggle()">
      <span class="dot">
        <i class="fa fa-bell" aria-hidden="true"></i>
        <span class="NotifyCount" *ngIf="notifyCount > 0">{{ notifyCount }}</span>
      </span>

      <div class="notify-panel" *ngIf="showNotifyPanel" (click)="$event.stopPropagation()">
        <div class="arrow-up"></div>
        <div class="notify-header">
          <span class="notify-label" style="color:#fff;">Notifications</span>
        </div>
        <div class="notify-content-body">
          <ul class="notify-list" *ngIf="notification.length; else noNotify">
            <li *ngFor="let item of notification" [class.notify-un-read]="!item.isRead"
              [class.notify-read]="item.isRead" (click)="openNotification(item)">
              <span class="new-badge" *ngIf="!item.isRead"></span>
              <p class="notify-title">{{ item.title }}</p>
              <p class="notify-msg">{{ item.body }}</p>
            </li>
          </ul>
          <ng-template #noNotify>
            <p class="text-center p-3">No notifications</p>
          </ng-template>
        </div>
      </div>
    </a> -->

    <a *ngIf="showEcgIcon" (click)="viewECG()"> <span class="dot"> <img
          matTooltip="ECG Files" src="images/03-waves.png" />
      </span> </a>
    <!-- Logout Section -->
    <a class="logout" (click)="logOut()">
      <span class="dot">
        <img matTooltip="LogOut" src="images/05-logout.png" />
      </span>
    </a>
  </div>
</mat-toolbar>